enum FilePickerAction {
    Attach,
    Share,
    Insert,
    AttachAndShare, //This action is responsible to attach the classic attachments and share the reference attachments selected in File Picker
}

export default FilePickerAction;
